// extracted by mini-css-extract-plugin
export default {"close-button":"close-button_close-button__HgYuu","closeButton":"close-button_close-button__HgYuu","OUTLINE":"close-button_OUTLINE__sGx3G","outline":"close-button_OUTLINE__sGx3G"};